/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 * Success Notification - Auto-dismissing success message
 * Updated: 2026-01-09
 */

import React, { useEffect } from 'react';
import { Check } from 'lucide-react';

interface SuccessNotificationProps {
  message: string;
  onDismiss: () => void;
  duration?: number; // ms
}

const SuccessNotification: React.FC<SuccessNotificationProps> = ({
  message,
  onDismiss,
  duration = 3000,
}) => {
  useEffect(() => {
    const timer = setTimeout(onDismiss, duration);
    return () => clearTimeout(timer);
  }, [onDismiss, duration]);

  return (
    <div className="animate-in fade-in slide-in-from-top-2 duration-300 bg-gradient-to-r from-emerald-500 to-green-500 rounded-lg p-3 shadow-lg">
      <div className="flex items-center gap-2">
        <Check className="w-5 h-5 text-white flex-shrink-0" />
        <p className="text-sm font-semibold text-white">{message}</p>
      </div>
    </div>
  );
};

export default SuccessNotification;
